import { CustomToast } from 'components';

export default function readModeApiResponse() {
  CustomToast({
    type: 'error',
    msg: 'Action not allowed with read-only access'
  });
  return Promise.reject({ notified: true });
}
